<template>
  <BottomDrawer
    v-if="state.payment"
    :is-shown="state.isShown && state.payment"
    @close="close"
  >
    <div class="content">
      <template v-if="state.payment.status === paymentStatuses.success">
        <div class="successIcon">
          <div class="gradient success"/>
        </div>

        <Typography
          variant="v20-700"
          center
          style="margin-top: 8px"
        >
          Оплачено
        </Typography>

        <Typography
          variant="v14-400"
          color="secondary"
          center
        >
          Чек отправлен на электронную почту {{ store.state.user.profile.email }}
        </Typography>
      </template>

      <template v-if="state.payment.status === paymentStatuses.pending">
        <div class="pendingIcon">
          <div class="gradient pending"/>
        </div>

        <Typography
          variant="v20-700"
          center
          style="margin-top: 8px"
        >
          Ожидаем подтверждение платежа
        </Typography>

        <Typography
          variant="v14-400"
          color="secondary"
          center
        >
          Это может занять некоторое время
        </Typography>
        <Typography
          variant="v14-400"
          color="secondary"
          center
        >
          После обработки платежа чек будет отправлен на электронную почту {{ store.state.user.profile.email }}
        </Typography>
      </template>

      <template v-if="state.payment.status === paymentStatuses.failed">
        <div class="failedIcon">
          <div class="gradient failed"/>
        </div>

        <Typography
          variant="v20-700"
          center
          style="margin-top: 8px"
        >
          Ошибка при обработке платежа
        </Typography>

        <Typography
          variant="v14-400"
          color="secondary"
          center
        >
          Убедись что на карте достаточно средств и попробуй ещё раз
        </Typography>
      </template>
    </div>

    <div class="modal-divider"/>

    <AppButton
      v-if="state.payment.status === paymentStatuses.success"
      full-width
      style="margin: 16px 0"
      @click="handleButtonClick"
    >
      {{ state.buttonChatList.text }}
    </AppButton>

    <AppButton
      v-if="state.payment.status === paymentStatuses.pending"
      full-width
      style="margin: 16px 0"
      @click="handlePendingButtonClick"
    >
      Проверить статус платежа
    </AppButton>

    <AppButton
      v-if="state.payment.status === paymentStatuses.failed"
      full-width
      style="margin: 16px 0"
      @click="handleFailedButtonClick"
    >
      Попробовать ещё раз
    </AppButton>

    <AppButton
      full-width
      style="margin: 16px 0"
      variant="secondary"
      @click="close"
    >
      Закрыть
    </AppButton>

  </BottomDrawer>
</template>

<script setup>
import BottomDrawer from '@/components/BottomDrawer.vue'
import { computed, onMounted, reactive, watch } from 'vue'
import AppButton from '@/components/UI/AppButton.vue'
import Typography from '@/components/UI/Typography.vue'
import store from '@/store/store.js'
import {router} from '@/router/router.js'
import {paymentStatuses, subscriptionStatuses} from '@/configs/subscriptionStatuses.js'

const props = defineProps({
  data: {
    type: Object,
    default: {},
  }
})

const state = reactive({
  isShown: false,

  subscription: null,
  payment: {
    status: 'pending'
  },

  buttonChatList: {},
})

const paymentId = props.data.query.payment_id || store.state.app.messageComponentData.query.payment_id

const userProfile = computed(() => {
  return store.state.user?.profile
})
const subscriptions = computed(() => {
  return userProfile.value?.subscriptions || []
})

watch(() => subscriptions.value, subscriptions => {
  if (subscriptions.length) {
    state.subscription = subscriptions.find(({ status }) => status === 'pending' || status === 'active')
    if (state.subscription) {
      state.payment = state.subscription.payments.find(p => p.id.toString() === paymentId.toString())
    }
  }

  setTimeout(() => {
    state.isShown = true
  }, 50)
}, { deep: true, immediate: true })

onMounted(() => {
  state.buttonChatList = store.state.user.directories.html_file.button_chat_list ?? {}
  state.subscription = store.state.user.profile.subscriptions.at(0)
  if (state.subscription) {
    state.payment = state.subscription.payments.find(p => p.id.toString() === paymentId.toString())
  }

  if(!state.payment) {
    return
  }

  setTimeout(() => {
    state.isShown = true
  }, 50)
})

function close() {
  state.isShown = false
  store.dispatch('app/setMessageComponent', null)
}

function handlePendingButtonClick() {
  state.isShown = false
  store.dispatch('app/setMessageComponent', null)
  router.push({name: 'SubscriptionControl'})
}

function handleFailedButtonClick() {
  state.isShown = false
  store.dispatch('app/setMessageComponent', null)
  router.push({name: 'SubscriptionControl'})
}

function handleButtonClick() {
  window.open(state.buttonChatList.link, '_blank')
}
</script>

<style lang="scss" scoped>

.modal-divider {
  width: 100%;
  height: 1px;
  background: var(--app-bar-border-color);
  margin: 16px 0;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  .gradient {
    position: absolute;
    width: 224px;
    height: 224px;
    left: -50%;
    top: -50%;

    &.success {
      background: radial-gradient(rgba(86, 231, 118, 0.35) 0%, rgba(88, 234, 120, 0.05) 25%, rgba(0, 0, 0, 0) 50%);
    }

    &.pending {
      background: radial-gradient(rgb(255, 153, 0, 0.35) 0%, rgba(255, 153, 0, 0.06) 25%, rgba(0, 0, 0, 0) 50%);
    }

    &.failed {
      background: radial-gradient(rgb(255, 48, 58, 0.35) 0%, rgba(255, 48, 58, 0.06) 25%, rgba(0, 0, 0, 0) 50%);
    }
  }

  .successIcon {
    position: relative;
    background-image: url("@/assets/icons/bigSuccess.svg");
    height: 112px;
    width: 112px;
  }

  .pendingIcon {
    position: relative;
    background-image: url("@/assets/icons/bigPending.svg");
    height: 112px;
    width: 112px;
  }

  .failedIcon {
    position: relative;
    background-image: url("@/assets/icons/bigFailed.svg");
    height: 112px;
    width: 112px;
  }
}
</style>
